var map = {
	"./pr-1.png": "4ea3",
	"./pr-10.png": "a89f",
	"./pr-2.png": "734c",
	"./pr-3.png": "e432",
	"./pr-4.png": "4154",
	"./pr-5.png": "d28b",
	"./pr-6.png": "69de",
	"./pr-7.png": "7fae",
	"./pr-8.png": "e6a5",
	"./pr-9.png": "e7bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2001";